module.exports = __webpack_public_path__ + "img/help37.1d2e2a60.png";